import { CREATE_BOOK_REPORT } from '@client/collections/Report/schemas/createBookReport'
import { gqlApiInstance } from '@client/init'
import { ReportBookType } from '@interfaces/ReportBookType'
import { ReportTypeEnum } from '@interfaces/ReportTypeEnum'

export function useReportAction() {
  async function createBookReport(
    title: ReportTypeEnum,
    detail: string,
    id: number,
    type: ReportBookType
  ): Promise<void> {
    await gqlApiInstance.request(CREATE_BOOK_REPORT, {
      createBookReportInput: {
        title,
        detail,
        id,
        type,
      },
    })
  }

  return {
    createBookReport,
  }
}
